import React, { useState } from 'react';
import { ICellRendererParams } from 'ag-grid-community';


interface ICustomCellRendererProps extends ICellRendererParams {
    value: string;
}

const CustomCellRenderer: React.FC<ICustomCellRendererProps> = (params) => {
    const [value, setValue] = useState(params.value ?? '');
    // Fall back to the true default field name (fieldName), not the row's current name - name is
    // only recomputed from customName at save time, so it still held the stale, last-saved custom
    // name here even after clearing the field, making the placeholder appear not to have reverted.
    const placeholder: string = params.data?.fieldName || params.data?.name || 'Enter value...';

    // Commit on every keystroke (not just on blur) and allow committing an empty value, so this
    // behaves the same as the worksheet-level Custom Name field: the Save button enables/disables
    // immediately as the user types/clears the field, instead of only updating once the cell loses
    // focus (and previously never updating at all when cleared to blank).
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setValue(newValue);

        const field = params.colDef?.field;

        if (field && newValue !== params.value) {
            params.node.setDataValue(field, newValue);
        }
    }

    // With the column no longer entering ag-Grid's edit mode, keydown events on this native
    // input would otherwise bubble up to the grid, where ag-Grid's built-in cell navigation/action
    // handling (arrows, Space, Delete, Backspace, etc.) could move focus or trigger grid behavior
    // instead of editing this field. Stop propagation so the input always receives/handles its own
    // keystrokes.
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        event.stopPropagation();
    }

    return (
        <input
            type="text"
            value={value}
            placeholder={placeholder}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            className="custom-cell-renderer-input"
            style={{
                width: '100%',
                paddingLeft: '8px',
                paddingRight: '8px',
                boxSizing: 'border-box',
                border: '1px solid #ccc',
                borderRadius: '4px',
            }}
            />
    );

};

export default CustomCellRenderer;
